export default {"src":"/_next/static/media/fonts.9634f847.svg","height":297,"width":338,"blurWidth":0,"blurHeight":0};